import { ocapiV1Routes } from '../routes';
export const salesApiRoutes = {
    masterData: {
        itemProfiles: {
            getForSite: (siteId) => `${ocapiV1Routes.sites}/${siteId}/item-profile`,
            getForGiftShop: () => `${ocapiV1Routes.giftShop}/item-profile`
        },
        items: {
            getByHopkForSite: (siteId, itemHopk) => `${ocapiV1Routes.sites}/${siteId}/sellable-items/by-hopk/${itemHopk}`
        },
        subscriptionBillingOptions: {
            getAll: () => `${ocapiV1Routes.prefix}/subscription-billing-options`
        },
        ticketPrices: {
            getForShowtime: (showtimeId) => `${ocapiV1Routes.showtimes}/${showtimeId}/ticket-prices`
        }
    },
    availability: {
        itemAvailability: {
            getForSite: (siteId) => `${ocapiV1Routes.sites}/${siteId}/item-availability`,
            getForGiftShop: () => `${ocapiV1Routes.giftShop}/item-availability`
        },
        discountAvailability: {
            getForSite: (siteId) => `${ocapiV1Routes.sites}/${siteId}/discount-availability`,
            getForShowtime: (showtimeId) => `${ocapiV1Routes.showtimes}/${showtimeId}/discount-availability`
        }
    }
};
//# sourceMappingURL=routes.js.map